import { gql } from "@apollo/client";

export const CREATE_MONITOR_EVENT_COMMENT = gql`
  mutation createMonitorEventComment(
    $input: CreateMonitoringEventCommentInput!
  ) {
    aml {
      createMonitorEventComment(input: $input) {
        success
      }
    }
  }
`;
